<template>
  <div>
    <div class="row">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item cursor-pointer" @click="$router.push({name: 'destinations'})">Destinations</li>
          <li class="breadcrumb-item active" aria-current="page">{{destinationTitle}}</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <slot name="main-image"></slot>
      </div>
      <div class="col-12 col-md-6">
        <template v-if="typeof destinationCopy === 'string'">
          <p>{{destinationCopy}}</p>
        </template>
        <template v-else>
          <p v-for="paragraph in destinationCopy">{{paragraph}}</p>
        </template>
        <div v-if="sideAsset">
          <img :src="getImagePath(sideAsset)" alt="" class="w-100">
        </div>
      </div>
    </div>
    <div v-if="bottomAsset">
      <img :src="getImagePath(bottomAsset)" alt="" class="w-100">
    </div>
    <destination-page-carousel v-if="assets" :assets="assets"/>
  </div>

</template>

<script>
  import DestinationPageCarousel from './destination-page-carousel';
  import {Destinations} from "../constants/destinations";

  export default {
    name: 'DestinationPageTemplate',
    components: {DestinationPageCarousel},
    props: ['destinationCopy', 'assets', 'sideAsset', 'bottomAsset'],
    computed: {
      destinationTitle: function () {
        return this.$route.meta.pageTitle.replace('Destinations - ', '');
      }
    },
    methods: {
      getImagePath: function (asset) {
        return `/static-assets/destinations/${asset}.jpg`;
      }
    }
  }
</script>

<style scoped lang="scss">
  .breadcrumb {
    background: none;
  }
</style>